import { AppointmentModel, IAppointment } from "./AppointmentModel";
import { ClinicModel } from "./ClinicModel";
import { Gender } from "./enums";

export interface TherapistModel {
    id: number;
    full_name: string;
    phone_number: string;
    gender: Gender;
    session_cost: number;
    speciality: string;
    description: string;

    has_photo: boolean;

    public_profile: boolean;
}

export interface IMyTherapist {
    agenda: PublicAgenda;
    next_appointment?: IAppointment;
}

export class MyTherapist implements IMyTherapist {
    agenda: PublicAgenda;
    next_appointment?: AppointmentModel;

    constructor(myTherapist: IMyTherapist) {
        this.agenda = myTherapist.agenda;
        this.next_appointment = myTherapist.next_appointment ? new AppointmentModel(myTherapist.next_appointment) : undefined;
    }
}

export interface PublicAgenda {
    therapist: TherapistModel;
    clinics: ClinicModel[];
}
